import { i18n } from '@flecto/translations'

export function useInsuranceTermsAndConditionsURL() {
  const language = i18n.language

  if (language === 'pt') {
    return 'https://drive.google.com/file/d/1POqmDavFsenAIS-xQCSUfxyTckB5dWyd'
  }

  if (language === 'es') {
    return 'https://drive.google.com/file/d/1i6qKRP6juHjxwRIa_WNN2LsyGH5KWMFj'
  }

  return 'https://drive.google.com/file/d/1C-7yoouzgvbqBGfJNoKRdpTuvuub21Dd'
}
